import { track, trackingEvents } from 'modules/core/lib/Tracking'

interface DownloadPdfOptions {
  url: string
  module: string
  source: string
  origin: string
}

export const downloadPdf = async (options: DownloadPdfOptions): Promise<void> => {
  const { url, module, source, origin } = options

  if (!url) {
    return
  }

  track(trackingEvents.marketplaceModules.downloadsPitchDeck, {
    source,
    module: module,
    origin,
  })

  try {
    const response = await fetch(url)
    if (!response.ok) {
      throw new Error(`Failed to fetch file: ${response.status}`)
    }

    const blob = await response.blob()

    const urlParts = url.split('/')
    const filename = urlParts[urlParts.length - 1] || 'pitch-deck.pdf'

    const downloadUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = downloadUrl
    link.download = filename
    document.body.appendChild(link)
    link.click()

    document.body.removeChild(link)
    window.URL.revokeObjectURL(downloadUrl)
  } catch (error) {
    window.open(url, '_blank')
  }
}
